export default __webpack_public_path__ + "static/media/ic_caret_down.08c14585.svg";